import { useState, useEffect } from "react";
import { Button } from "../components/ui/button";

// Usa sempre URL relativi - funziona su qualsiasi dominio
const BACKEND_URL = "";

export default function LoginPage({ onLogin }) {
  const [isSetup, setIsSetup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nome, setNome] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/auth/check`)
      .then(res => res.json())
      .then(data => setIsSetup(!data.has_account))
      .catch(() => setIsSetup(true))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const endpoint = isSetup ? "/api/auth/setup" : "/api/auth/login";
      const body = isSetup
        ? { email, password, nome }
        : { email, password };

      const res = await fetch(`${BACKEND_URL}${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        setError(errData.detail || `Errore ${res.status}: ${res.statusText}`);
        return;
      }

      const data = await res.json();

      localStorage.setItem("auth_token", data.token);
      localStorage.setItem("auth_nome", data.nome || "");
      onLogin(data);
    } catch (err) {
      setError(`Errore di connessione: ${err.message} (URL: ${BACKEND_URL || window.location.origin}/api/auth/login)`);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-pulse text-slate-400">Caricamento...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="login-page">
      <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 w-full max-w-sm">
        <div className="text-center mb-6">
          <h1 className="text-xl font-bold text-slate-800">
            SC Dottori Commercialisti
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            {isSetup ? "Crea il tuo account" : "Accedi al portale"}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {isSetup && (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Nome</label>
              <input
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                placeholder="Es. Silvia Casali"
                data-testid="setup-nome-input"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              placeholder="email@studio.com"
              required
              data-testid="login-email-input"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              placeholder="La tua password"
              required
              data-testid="login-password-input"
            />
          </div>

          {error && (
            <div className="text-red-600 text-sm bg-red-50 px-3 py-2 rounded-lg border border-red-200" data-testid="login-error">
              {error}
            </div>
          )}

          <Button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5"
            disabled={submitting}
            data-testid="login-submit-btn"
          >
            {submitting ? "Attendere..." : isSetup ? "Crea account" : "Accedi"}
          </Button>

          <button
            type="button"
            onClick={() => { setIsSetup(!isSetup); setError(""); }}
            className="w-full text-center text-sm text-blue-600 hover:text-blue-800 hover:underline mt-2"
            data-testid="toggle-auth-mode"
          >
            {isSetup ? "Hai già un account? Accedi" : "Non hai un account? Creane uno"}
          </button>
        </form>
      </div>
    </div>
  );
}
